export default __webpack_public_path__ + "static/media/ProjectionFootplant.75369a8d.png";